exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-31a4a6a0] .el-loading-mask{background-color:#1e4960!important;opacity:1!important}", ""]);

// exports
